import { Container, Grid } from '@mui/material';
import * as React from 'react';
import { Label } from 'semantic-ui-react';
import { IHelper, Helper } from '../services';
import { OpenMenuComponent, RadioCheckBoxComponent, OpenLinkedDocument } from '../components';
import styles from './SearchResultsFlat.module.scss';

interface ISearchResultsFlatProps {
    result: any;
    index: any;
    clickHandle: any;
    searchText: string;
}

export class SearchResultsFlat extends React.Component<ISearchResultsFlatProps, {}> {
    private _helpers: IHelper = new Helper();

    public render() {
        return (
            <div>
                {this.renderSearchResultFlat()}
            </div>
        )
    }


    private renderSearchResultFlat() {
        return (
            <div key={this.props.index} className={styles.searchResultsFlat}>
                <Container>
                <Grid container spacing={1} className={styles.grid}>
                    <Grid item xs={8} onClick={this.props.clickHandle}>
                        <div className={styles.tag}>{this.props.result.division}</div>
                        <div className={styles.title}>{this._helpers.ShowAllTitles(this.props.result.title)}</div>
                        <div className={styles.author}>{this.props.result.author}</div>
                        <div className={styles.docTags}>
                        {this.props.result.documentType.length > 0 ? this.generateDocTagsFlat(this.props.result.documentType) : <></>}
                        </div>
                    </Grid>
                    <Grid item xs={3} className={styles.middle}>
                        <div className={styles.date}>{this._helpers.FormatDate(this.props.result.contractDate)}</div>
                        {this.props.result.confidential ? <div className={styles.reversion}>Confidential</div> : <></>}
                        <div className={styles.menuSeparator}>|</div>
                    </Grid>
                    <Grid item xs={1} className={styles.rightMenu}>
                        <div className={styles.checkbox}>
                            <RadioCheckBoxComponent />
                        </div>
                        <div className={styles.menu}><OpenMenuComponent /></div>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                        <div className={styles.linkedDocs}><OpenLinkedDocument relatedDocs={this.props.result.relatedKey} searchText={this.props.searchText} docId={this.props.result.id} title={this.props.result.title} /></div>                    
                        </Grid>
                    </Grid>
                </Grid>
                </Container>
            </div>
        )
    }

    private generateDocTagsFlat(docs: any) {
        return docs.map((doc: any, index: any) => {
            return <Label key={index} className={styles.docTag}>{doc}</Label>;
        });
    }
}